<div class="opening-hours">
	<ul>
		@for (time of formattedHours; track time) {
			<li>
				{{ time }}
			</li>
		}
	</ul>
</div>
